import { useFormikContext } from 'formik';
import { Component } from './styled';
export function Fieldset(props) {
    const { children, disabled, disableOnSubmit } = props;
    const { isSubmitting } = useFormikContext();
    const isDisabled = (isSubmitting && disableOnSubmit) || disabled;
    return <Component disabled={isDisabled}>{children}</Component>;
}
